import { render, staticRenderFns } from "./CommonInputFile.vue?vue&type=template&id=4f3fa7c8"
import script from "./CommonInputFile.vue?vue&type=script&lang=js"
export * from "./CommonInputFile.vue?vue&type=script&lang=js"
import style0 from "./CommonInputFile.vue?vue&type=style&index=0&id=4f3fa7c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports